import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface EventColumnErrorFallbackProps {
  title?: string;
  onRetry?: () => void;
}

export function EventColumnErrorFallback({
  title = 'Events',
  onRetry,
}: EventColumnErrorFallbackProps) {
  return (
    <div className="h-full flex flex-col rounded-lg overflow-hidden">
      {/* Column Header */}
      <div className="flex items-center justify-between p-2 ps-4">
        <div className="flex items-center space-x-2">
          <h2 className="font-semibold text-gray-900">{title}</h2>
        </div>
      </div>

      {/* Error Content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <Card className="w-full max-w-sm p-6 border-red-200 bg-red-50">
          <div className="text-center">
            <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-red-900 mb-2">
              Failed to load events
            </h3>
            <p className="text-sm text-red-700 mb-4">
              There was an error loading the events column. Please try again.
            </p>
            {onRetry && (
              <button
                onClick={onRetry}
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-700 bg-white border border-red-300 rounded-lg hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
              >
                <RefreshCw className="h-4 w-4" />
                Try Again
              </button>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
